<template>
  <div class="innerItem">
    <div>
      <p class="innerTitle setLabel">{{locale.setting_font_default}}</p>
      <select class="input inlineInput" v-model="font.default">
        <option v-for="(font, index) in fontList" :key="index" :value="font.family" :style="{fontFamily: font.family}">{{font.family}}</option>
      </select>
      <div class="mt5">
        <select class="input inlineInput" v-model="font.default2">
          <option
            v-for="(font, index) in fontList"
            :key="index"
            :value="font.family"
            :style="{fontFamily: font.family}"
            :disabled="font.family === font.default || font.default3">
            {{font.family}}
          </option>
        </select>
      </div>
      <div class="mt5">
        <select class="input inlineInput" v-model="font.default3">
          <option
            v-for="(font, index) in fontList"
            :key="index"
            :value="font.family"
            :style="{fontFamily: font.family}"
            :disabled="font.family === font.default || font.default2">
            {{font.family}}
          </option>
        </select>
      </div>
    </div>
    <div class="mt30">
      <p class="innerTitle setLabel">{{locale.setting_font_added}}</p>
      <input type="file" id="uploadFont" @change="uploadFont($event)">
      <label for="uploadFont" class="btn toUppercase">{{locale.upload}}</label>
      <ul class="uploadFontList">
        <li v-for="font in font.added" :key="font.file">
          <span :style="{fontFamily: font.family}">{{font.file}}</span>
          <button class="btnDel" @click="delFont(font)"><img src="~@/assets/img/ico_close.svg" alt=""></button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import UPLOAD from '@/common/upload'
import UNIQUE from '@/common/unique'

export default {
  name: 'Setfont',
  props: [
    'locale',
    'font'
  ],
  computed: {
    fontList () {
      return this._.merge(this.font.list, this.font.added)
    }
  },
  methods: {
    uploadFont (e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isWebfont = regExp.webfont.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isWebfont) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          const fileName = res.name
          const fontFamily = fileName.replace(`.${res.format}`, '')
          const isExact = this.font.added.filter(x => x.family === fontFamily).length > 0
          if (!isExact) {
            const fontData = {}
            fontData.family = fontFamily
            fontData.file = fileName
            fontData.uri = res.source
            this.$store.commit('setting/addFonts', fontData)
            this.$store.commit('setting/setFontFace', fontData)
            e.target.value = ''
          }
        })
      } else {
        alert(this.locale.validate_upload_webfont)
      }
    },
    delFont (font) {
      // this.$store.commit('util/removeUploadFiles', font.id)
      this.$store.commit('setting/delFonts', font)
    }
  }
}
</script>

<style lang="scss" scoped>
.uploadFontList {
  li {
    margin-top: 0.6em;
  }
  span {
    display: inline-block;
    margin-right: 0.6em;
    vertical-align: middle;
    color: $color-grey;
    text-decoration: underline;
  }
  .btnDel {
    display: inline-block;
    padding: 4px;
    font-size: 0;
    vertical-align: middle;
    background-color: $color-lgrey;
    img {
      width: 10px;
    }
  }
}
</style>
